// This is for the original mobile nav, which will eventually be removed.
export function mobileMenu() {
    if (document.getElementById('header') && document.getElementById('headerMobileTrigger')){
        var header = document.getElementById('header');
        var headerMobileTrigger = document.getElementById('headerMobileTrigger');

        var mobileMenuOpenClose = function () {
            header.classList.toggle('active');
        }
        headerMobileTrigger.addEventListener('click', mobileMenuOpenClose);
    }
}

